import ConfirmationDialog from "../components/UtilityComponents/ConfirmationDialog";
import routeMapper from "../router/routeMapper";
import sunsetShareHelper from "../helper/SunsetShareHelper";
import * as mutationTypes from "../store/mutation-types";
import appConfig, {channelEnum} from "../appconfig";
import MysteryBoxProvider from "../providers/MysteryBoxProvider";

export default {
	components: { ConfirmationDialog },
	data() {
		return {
			dialogOpened: false,
			currentConfirmAction: null,
			isProtectOrderFlow: false
		};
	},
	methods: {
		protectOrderFlow(action, targetRoute = null) {
			this.currentConfirmAction = () => {
				if(this.$store.getters.cartProducts.length === 0) {
					sunsetShareHelper.cancelGroupOrder();
				}
				this.$store.commit(mutationTypes.SET_REORDER_STATE);
				if(this.$store.getters.voucherVirtualOrderId) {
					MysteryBoxProvider.changeStatusMysteryBox(this.$store.getters.voucherVirtualOrderId)
						.then(() => {});
				}
				action();
			};
			if (sunsetShareHelper.isUserGroupOrderOwner() && this.$store.getters.cartProducts.length === 0) {
				this.dialogOpened = true;
				return;
			}

			if((!this.isMobileChannel || targetRoute === routeMapper.routeNames.shopSelection)
				&& this.featureToggles.enableProtectOrderingFlow &&
				this.$store.getters.cartProducts.length > 0) {
				this.dialogOpened = true;
			} else {
				return action();
			}
		},
		closeConfirmDialog() {
			this.dialogOpened = false;
		}
	},
	computed: {
		isMobileChannel() {
			return appConfig.channelAlias() === channelEnum.mobileBrowser
				|| appConfig.channelAlias() === channelEnum.mobileApp;
		}
	}
};
